export const Languages: Language[]  = [
    {  code: 'en', long: 'English' },
    {  code: 'de', long: 'German' },
];

export class Language{
    code: string;
    long: string;
}


// WEBPACK FOOTER //
// ./src/app/dicts/languages.ts